import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/tabs/style";
import _Tabs from "antd/lib/tabs";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-设备流量*/
import React from 'react';
import * as echarts from "echarts";
import { parse } from "../../../../utils/commonUtilFunc";
import { addComma } from "../../../../utils/commonUtilFunc";
import { chartColor, pieChartColor } from '../../../../utils/commonConsts';
import { withRouter } from "react-router-dom";
import UserFlowRankTab from "./AppRankSubs/UserFlowRankTab";
import DayFlowChart from "./AppRankSubs/DayFlowChart";
import { connect } from "dva";
import { injectIntl } from "react-intl";
import DesIpFlowChart from "./AppRankSubs/DesIpFlowChart";
var Option = _Select.Option;
var TabPane = _Tabs.TabPane;
var AppRank = /*#__PURE__*/function (_React$Component) {
  _inherits(AppRank, _React$Component);
  function AppRank(props) {
    var _this;
    _classCallCheck(this, AppRank);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppRank).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_step_apps", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_step_apps",
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          tunnel_dir: _this.tunnel_dir_id,
          sn: _this.sn,
          top: _this.state.top,
          name: _this.state.name,
          company_id: _this.ifCompany ? _this.company_id : sessionStorage.getItem("companyId")
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      vm.setState({
        top: value
      }, function () {
        vm.get_step_apps();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        name: e.target.value
      }, function () {
        if (_this.state.name === "") {
          vm.get_step_apps();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseAppFlowDetailModal", function () {
      _this.setState({
        ifAppFlowDetailModalShow: false,
        selectedAppId: "",
        selectedAppNm: "",
        selectedAppFlow: "0"
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function (element) {
      var option = {
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisTick: {
            show: false
          },
          name: "MB",
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          }
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(0,0,0,0.45)"
            }
          },
          nameTextStyle: {
            fontSize: 8
          },
          axisLabel: {
            interval: 0
          },
          inverse: true
        },
        series: [{
          name: "flow",
          type: 'bar',
          data: _this.props.ci0303Info.step_apps_flow,
          itemStyle: {
            normal: {
              color: function color(params) {
                return pieChartColor[params.dataIndex % chartColor.length];
              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          barCategoryGap: "60%",
          barMinHeight: "10",
          barMaxWidth: 32
        }],
        color: ["red", "yellow"]
      };
      element.setOption(option);
      element.resize({
        width: _this.state.chartWidth,
        height: 500
      });
    });
    _this.state = {
      chartWidth: document.body.clientWidth > 1366 ? document.body.clientWidth - 320 : 1366 - 320,
      ifAppFlowDetailModalShow: false,
      selectedAppId: "",
      selectedAppNm: "",
      selectedAppFlow: "0",
      top: '5',
      name: ""
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir = search.tunnel_dir;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    _this.company_id = search.id;
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(AppRank, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var vm = this;
      this.get_step_apps();
      this.element = echarts.init(document.getElementById('app-rank'));
      this.element.on('click', function (params) {
        vm.setState({
          ifAppFlowDetailModalShow: true,
          selectedAppNm: params.data[3],
          selectedAppId: params.data[2],
          selectedAppFlow: params.data[0]
        });
      });
      this.props.onRef(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderChart(this.element);
    }
  }, {
    key: "render",
    value: function render() {
      var search = parse(this.props.location.search);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 120,
          marginRight: 8,
          marginTop: 16
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter keywords",
        style: {
          width: 240,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_step_apps
      }, "search"), /*#__PURE__*/React.createElement("div", {
        id: "app-rank"
      }), /*#__PURE__*/React.createElement(_Modal, {
        title: "Application traffic details",
        footer: null,
        visible: this.state.ifAppFlowDetailModalShow,
        width: 925,
        onCancel: this.handleCloseAppFlowDetailModal,
        destroyOnClose: true
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
        className: "title-device-name"
      }, "apply name", ":", this.state.selectedAppNm), /*#__PURE__*/React.createElement("div", {
        className: "title-device-info"
      }, /*#__PURE__*/React.createElement("span", null, "time slot", ":\xA0\xA0", search.start_tm, "\xA0", "to", "\xA0", search.end_tm), /*#__PURE__*/React.createElement("span", null, "Traffic type", ":\xA0\xA0", search.tunnel_dir), /*#__PURE__*/React.createElement("span", null, "Traffic size", ":\xA0", addComma(this.state.selectedAppFlow), "\xA0\xA0MB"))), /*#__PURE__*/React.createElement(_Tabs, null, /*#__PURE__*/React.createElement(TabPane, {
        tab: "User Ranking",
        key: "1"
      }, /*#__PURE__*/React.createElement(UserFlowRankTab, {
        ids: this.state.selectedAppId,
        flow: this.state.selectedAppFlow
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "Daily flow trend chart",
        key: "2"
      }, /*#__PURE__*/React.createElement(DayFlowChart, {
        ids: this.state.selectedAppId
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "Target IP traffic",
        key: "3"
      }, /*#__PURE__*/React.createElement(DesIpFlowChart, {
        ids: this.state.selectedAppId,
        flow: this.state.selectedAppFlow
      })))));
    }
  }]);
  return AppRank;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(AppRank)));